import { render, staticRenderFns } from "./CardTarjaEstrelaDaCasa.vue?vue&type=template&id=29d9f881&scoped=true"
import script from "./CardTarjaEstrelaDaCasa.vue?vue&type=script&lang=js"
export * from "./CardTarjaEstrelaDaCasa.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEstrelaDaCasa.vue?vue&type=style&index=0&id=29d9f881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d9f881",
  null
  
)

export default component.exports